import { apiDaInscricao } from "../../../servicos/axios";

interface Payload {
  dataAbertura: string;
  dataFechamento: string | null;
}

export const atualizarPermissaoCidade = async (
  id: number,
  payload: Payload
): Promise<void> => {
  await apiDaInscricao().put(
    `/permissaoDasCidades/${id}/editar-permissao`,
    payload
  );
};
